import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Treatments.css";
import logo from '../images/6_Ayur copy.webp'
import serviceImg from "../images/main_reju.webp";
import { MdOutlineMail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import AyurvedaFooter from "../AyurvedaFooter/AyurvedaFooter";
import ScrollToTop from '../ScrollToTop'
import { MdCall } from "react-icons/md";
import { Link, NavLink, useLocation } from "react-router-dom";
import WhatsAppButton from "../WhatsAppButton";
import { FaLocationArrow } from "react-icons/fa6";
import ScrollTop from "../ScrollTop";
import { Helmet } from 'react-helmet-async';

export default function Rejuvenation() {
  const location = useLocation();

  const isTreatmentActive =
    location.pathname.startsWith("/treatment") ||
    location.pathname.startsWith("/postnatal") ||
    location.pathname.startsWith("/rejuvenation") ||
    location.pathname.startsWith("/hair_treatment") ||
    location.pathname.startsWith("/lifestyle_yoga") ||
    location.pathname.startsWith("/soundarya_kalpa");
  return (
    <>
    <Helmet>
  <title>
    Rejuvenation Therapy in Kerala
  </title>

  <meta
    name="description"
    content="Experience deep healing and renewal with authentic Ayurvedic Rejuvenation Therapy at Ayurmoksha Ayurveda Hospital in Kozhikode, Kerala. Our classical rejuvenation treatments detoxify the body, restore energy, improve immunity, relieve stress, and promote long-term wellness using traditional Ayurvedic therapies and herbal medicines."
  />

  <meta
    name="keywords"
    content="Ayurvedic Rejuvenation Therapy Kozhikode, Ayurveda Rejuvenation Kerala, Stress Relief Ayurveda Kerala, Ayurvedic Detox Treatment Kerala, Ayurmoksha Rejuvenation Therapy, Best Ayurveda Hospital in Kozhikode"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/rejuvenation" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Ayurvedic Rejuvenation Therapy | Ayurmoksha Ayurveda Hospital Kozhikode Kerala"
  />
  <meta
    property="og:description"
    content="Ayurmoksha Ayurveda Hospital in Kozhikode offers traditional Ayurvedic Rejuvenation Therapy to detoxify the body, reduce stress, enhance vitality, and restore balance through authentic healing practices."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/rejuvenation"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda Hospital"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Ayurvedic Rejuvenation Therapy at Ayurmoksha Ayurveda Hospital in Kozhikode Kerala"
  />

  <meta name="author" content="Ayurmoksha Ayurveda Hospital" />
</Helmet>

    <ScrollTop/>
     {/* main section */}
      <section className="container-fluid about-main-section">
      {/* Overlay */}
      <div className="about-main-overlay"></div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark about-navbar">
        <div className="container">

          {/* Logo */}
           <Link className="navbar-brand" to="#"><span><img src={logo} alt="logo" className="brand-logo bg_new"/><span  className=" logo_txt mt-5" ></span></span>
          </Link>

          {/* Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#aboutNavbar"
            aria-controls="aboutNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse justify-content-center" id="aboutNavbar">

             <ul className="navbar-nav align-items-lg-center gap-lg-3 text-center">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Home</b></NavLink>
              </li>

              <li className="nav-item">
              
                <NavLink  className="nav_Active" to="/ourstory" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Our Story</b></NavLink>
              </li>
<li className="nav-item dropdown">
  <NavLink
    to="/treatment"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={() => ({
      color: isTreatmentActive ? "orange" : "white"
    })}
  >
    <b>Treatments</b>
  </NavLink>

  <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        All Treatments
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/postnatal"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Postnatal Care
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/rejuvenation"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Rejuvenation Therapy
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/hair_treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Hair Treatment
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/lifestyle_yoga"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Life Style Guidance & Yoga
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/soundarya_kalpa"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Soundarya Kalpa
      </NavLink>
    </li>
  </ul>
</li>

                <li className="nav-item">
                  <NavLink className="nav_Active" to="/contact" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>contact</b></NavLink>
              </li>
             
            </ul>
          </div>

        </div>
        <div className="d-none d-lg-flex align-items-center gap-3 ms-auto">
<span className="phone-inline">
  <MdCall /> <b>+91 7736 111 482</b>
</span>


  <a
    href="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20treatments"
    target="_blank"
    rel="noopener noreferrer"
    className="messenger-btn"
    style={{ backgroundColor: "#006400", textDecoration: "none" }}
  >
    WhatsApp
  </a>
</div>

      </nav>

      {/* Center Content */}
      <div className="about-main-content">
        <h1 className="head-font" style={{color:'#f7f0d3'}}>Rejuvenation Therapy</h1>
        <p>
          <span className="para-font">Home</span>
          <span className="mx-2">»</span>
          <span className="para-font">Rejuvenation Therapy</span>
        </p>
      </div>
    </section>
    {/* =========== */}
    <section className="service-detail-wrapper">
      <div className="container">
        <div className="row">

          {/* LEFT CONTENT */}
          <div className="col-lg-8 mb-5 mb-lg-0">
            <div className="service-image">
              <img src={serviceImg} alt="Abhyanga Therapy" style={{height:'500px'}}/>
            </div>

            <h2 className="service-title head-font">Rejuvenation Therapy</h2>

            <p className="service-desc para-font justify-text">
           Rejuvenation Therapy (Rasayana Chikitsa) is a holistic clarifying and nourishing Ayurvedic treatment designed to restore vitality, slow down aging, and enhance overall well-being. It helps detoxify the body, strengthen immunity, and rejuvenate the mind, leaving you refreshed, energized, and balanced.
To support healing, our clinic is set in an environment that naturally enhances rejuvenation. Nestled along a gently flowing river and surrounded by lush medicinal gardens, it offers a serene Ayurvedic retreat where nature becomes an integral part of therapy. The soft river breeze, rustling leaves, and vibrant greenery create a deep sense of calm, allowing the body and mind to relax and respond fully to treatment. Our medicinal gardens ensure the purity and potency of every rejuvenation therapy, while guided yoga sessions in our river-view yoga hut restore flexibility, mental clarity, and inner balance.

            </p>

            <h5 className="service-subtitle head-font">Benefits</h5>

            <div className="row service-benefits">
              <div className="col-md-6">
               <ul className="para-font benefit-list">
  <li>
    <span className="tick">✔</span>
    <span className="text">
      Preparation of the body to mitigate the impact of future outbreaks
    </span>
  </li>

  <li>
    <span className="tick">✔</span>
    <span className="text">
      Slows down the aging process and promotes longevity
    </span>
  </li>

  <li>
    <span className="tick">✔</span>
    <span className="text">
      Nourishes body tissues and supports cellular regeneration
    </span>
  </li>

  <li>
    <span className="tick">✔</span>
    <span className="text">
      Calms the nervous system, reducing stress, anxiety and mental fatigue
    </span>
  </li>
</ul>

              </div>
             <div className="col-md-6">
  <ul className="para-font benefit-list">
    <li>
      <span className="tick">✔</span>
      <span className="text">
        Restores physical strength, stamina, and vitality
      </span>
    </li>

    <li>
      <span className="tick">✔</span>
      <span className="text">
        Detoxifies the body by eliminating accumulated toxins
      </span>
    </li>

    <li>
      <span className="tick">✔</span>
      <span className="text">
        Improves quality of sleep and relieves insomnia
      </span>
    </li>

    <li>
      <span className="tick">✔</span>
      <span className="text">
        Enhances adaptability to modern lifestyle stress
      </span>
    </li>
  </ul>
</div>

            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="service-sidebar">

              <div className="sidebar-card">
                <h5 className="head-font" style={{color:'wheat'}}>Our Services</h5>
                  <ul className="para-font">
                    <li><FaLocationArrow />&nbsp;&nbsp;Postnatal Care</li>
                     <li><FaLocationArrow />&nbsp;&nbsp;Rejuvenation Therapy</li>
                     <li><FaLocationArrow />&nbsp;&nbsp;Hair Treatments</li>
                      <li><FaLocationArrow />&nbsp;&nbsp;Life Style Guidance & Yoga</li>
                       <li><FaLocationArrow />&nbsp;&nbsp;Soundarya Kapla</li>
                  </ul>
              </div>

              <div className="sidebar-card">
                 <h5 className="head-font" style={{color:'wheat'}}>Treatment overview </h5>
                       <ul className="para-font">
                          <li><FaLocationArrow />&nbsp;&nbsp;Abhyangam</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Swedana</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Udwarthanam</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Pizhichil</li>
                           <li><FaLocationArrow />&nbsp;&nbsp;Shiro Abhyangam</li>
                             <li><FaLocationArrow />&nbsp;&nbsp;Shirodhara / Thakradhara / Kashayadhara</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Njavara Kizhi</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Virechanam</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Vasthi</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Nasya</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Anjanam</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Keshadhoomam</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Snehapana</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Thalam</li>
                            <li><FaLocationArrow />&nbsp;&nbsp;Face packs & herbal lepanam</li>
                            
                         </ul>
              </div>

              <div className="sidebar-card">
                <h5 className="head-font" style={{color:'wheat'}}>Our Contact</h5>
                      <ul className="para-font">
                         <li><FaPhone/> +91 7736 111 482</li>
                        <li><MdOutlineMail/> ayurmokshacalicut@gmail.com</li>
                      <li><FaLocationDot/>&nbsp;Ruby Road, Karuvanthuruthy, Feroke, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Kozhikode,Kerala 673631</li>
                   </ul>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
    <AyurvedaFooter/>
 <ScrollToTop/>
  <WhatsAppButton />
    </>
  );
}
